import React, { useState, useEffect } from "react";
// redux
import { useDispatch, useSelector } from "react-redux";
import { fetchAllSenders } from "../../store/categoryUserList";
// kendo
import { Checkbox,TextBox, InputSuffix,InputSeparator } from "@progress/kendo-react-inputs";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";
// css
import "./dialog.css";
import { Icon } from "@progress/kendo-react-common";
import SearchIcon from "../../assets/communication/search_icon.svg";

export const SenderListDialog = (props) => {
  const dispatch = useDispatch();
  const [selectedSenders, setSelectedSenders] = useState(props.defaultSelected);
  const { senders_loading, senders, senders_error } = useSelector(
    (state) => state.categoryUserList
  );
  const [searchValue, setSearchValue] = useState("");
  const [filteredGroupUsers, setFilteredGroupUsers] = useState([]);
  let delay;
  useEffect(() => {
    if (senders.length > 0) {
      setFilteredGroupUsers(senders);
    }
  }, [senders]);  
  useEffect(() => {
    dispatch(fetchAllSenders());
  }, []);
  const handleSelected = (e, val) => {
    let updatedList = [...selectedSenders];
    if (e.target.value) {
      updatedList = [...selectedSenders, val];
    } else {
      const selected_index = selectedSenders
        .map((v) => v.username)
        .indexOf(val.username);
      updatedList.splice(selected_index, 1);
    }
    setSelectedSenders(updatedList);
  };
  const handleSubmitDepots = () => {
    let newSelectedSenders = senders.filter((v1)=> selectedSenders.some((v2)=> v1.username === v2.username));
    console.log(newSelectedSenders);
    props.callback(newSelectedSenders);
  };
  const filterGroupUsers = () => {
    console.log("filterGroupUsers: ", searchValue);
    console.log();
    if (searchValue === "") {
      setFilteredGroupUsers(senders);
    } else {
      const groups = senders.filter(
        (x) =>
          (x.username !== null &&
            x.username.includes(searchValue.toLowerCase())) ||
          (x.name !== null &&
            x.name.toLowerCase().includes(searchValue.toLowerCase()))
      );
      console.log("filterGroupUsers groups:", groups);
      setFilteredGroupUsers(groups);
    }
  }; 
  useEffect(() => {
    delay = setTimeout(() => {
      if (
        (searchValue.length >= 3 || searchValue.length === 0) &&
        senders.length > 0
      )
        filterGroupUsers();
    }, 1000);

    return () => clearTimeout(delay);
  }, [searchValue]);

  const handleSearchTextChanged = React.useCallback((event) => {
    setSearchValue(event.target.value);
    console.log("handleChange: ", event.target.value);
  }, []);

  const isChecked = (item) =>
    selectedSenders.map((v) => v.username).includes(item) ? true : false;
  return (
    <Dialog
      title={`Please select sender(s): ${selectedSenders.length} selected`}
      width={500}
      height={500}
      onClose={props.onClickNo}
      className="sender-dialog"
    >
      <div className="sender-list-div">
        {senders_loading ? (
          <Loader
            type="infinite-spinner"
            style={{
              display: "flex",
              alignItems: "center",
              width: "40px",
              margin: "auto",
              justifyContent: "center",
              height: "350px",
            }}
          />
        ) : (
          <>
          <TextBox
              className="group-user-search-box-txtbox"
              value={searchValue}
              onChange={handleSearchTextChanged}
              placeholder="Search by Username / Name (min 3 characters)"
              suffix={() => (
                <>
                  <InputSuffix>
                    <Icon>
                      <img src={SearchIcon} />
                      &nbsp;
                    </Icon>
                  </InputSuffix>
                  <InputSeparator />
                </>
              )}
            />
          {filteredGroupUsers.filter((x)=> x.is_active == true).map((v) => (
            <Checkbox
              label={`${v.name} (${v.username})`}
              onChange={(e) => handleSelected(e, v)}
              checked={isChecked(v.username)}
            />
          ))}
          </>
          
        )}
      </div>
      <DialogActionsBar>
        <button
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base sender-cancel-button"
          onClick={props.onClickNo}
        >
          No
        </button>
        <button
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base sender-submit-button"
          onClick={handleSubmitDepots}
        >
          Yes
        </button>
      </DialogActionsBar>
    </Dialog>
  );
};
